import { REQUEST_CREDIT_HISTORY, RECEIVE_CREDIT_HISTORY, ICreditHistoryState, CreditHistoryTypes } from "./types";
import { REQUEST_CREDIT_DATA, RECEIVE_CREDIT_DATA, ICreditDataState, CreditTypes, ICreditResponse } from "./types";
import { RECEIVE_ONETIME_CREDIT, IOneTimeCreditState } from "./types";
import { REQUEST_DAILY_CREDIT, RECEIVE_DAILY_CREDIT, IDailyCreditState } from "./types";
import { REQUEST_CREDIT_AUTH, RECEIVE_CREDIT_AUTH, ICreditAuthState, CreditAuthTypes, ICreditAuthResponse, ICreditEnrollmentDetailsState, CREDIT_ENROLLMENT_DETAILS, LOADER_FOR_CREDIT_ENROLLMENT_DETAILS } from "./types";

const creditHistoryInitialState: ICreditHistoryState = {
    isLoading: false,
    creditHistoryData: [],
    isPurchaseDisabled: false,
    hasOneTimeReport: false,
    hasOneTimeScore: false,
    isOneTimeOnlyScore: false,
    isOneTimeOnlyReport: false,
    isOneTimeReportLatest: false,
    oneTimeScoreServiceCode: "",
    oneTimeReportServiceCode: "",
};

export function creditHistoryReducer(state = creditHistoryInitialState, action: CreditHistoryTypes): ICreditHistoryState {
    if (state === undefined) {
        return creditHistoryInitialState;
    }

    switch (action.type) {
        case REQUEST_CREDIT_HISTORY:
            return {
                isLoading: true,
                creditHistoryData: state.creditHistoryData,
                isPurchaseDisabled: action.isPurchaseDisabled,
                hasOneTimeReport: action.hasOneTimeReport,
                hasOneTimeScore: action.hasOneTimeScore,
                isOneTimeOnlyScore: action.isOneTimeOnlyScore,
                isOneTimeOnlyReport: action.isOneTimeOnlyReport,
                isOneTimeReportLatest: action.isOneTimeReportLatest,
                oneTimeScoreServiceCode: action.oneTimeScoreServiceCode,
                oneTimeReportServiceCode: action.oneTimeReportServiceCode,
            };
        case RECEIVE_CREDIT_HISTORY:
            return {
                isLoading: false,
                creditHistoryData: action.creditHistoryData,
                isPurchaseDisabled: action.isPurchaseDisabled,
                hasOneTimeReport: action.hasOneTimeReport,
                hasOneTimeScore: action.hasOneTimeScore,
                isOneTimeOnlyScore: action.isOneTimeOnlyScore,
                isOneTimeOnlyReport: action.isOneTimeOnlyReport,
                isOneTimeReportLatest: action.isOneTimeReportLatest,
                oneTimeScoreServiceCode: action.oneTimeScoreServiceCode,
                oneTimeReportServiceCode: action.oneTimeReportServiceCode,
            };
        default:
            return state;
    }
}

let creditResponse: ICreditResponse | any;

const initialCreditDataState: ICreditDataState = { isLoading: false, creditData: creditResponse, hasError: false, hasErrorCount: 0 };

export function creditDataReducer(state = initialCreditDataState, action: CreditTypes): ICreditDataState {
    if (state === undefined) {
        return initialCreditDataState;
    }

    switch (action.type) {
        case REQUEST_CREDIT_DATA:
            return {
                ...state,
                isLoading: true,
                creditData: state.creditData,
            };
        case RECEIVE_CREDIT_DATA:
            return {
                ...state,
                isLoading: false,
                creditData: action.creditData,
                hasError: action.hasError,
                hasErrorCount: action.hasErrorCount,
            };
        default:
            return state;
    }
}

const initialOneTimeCreditState: IOneTimeCreditState = { oneTimeCreditData: creditResponse, purchasedReport: false, pageViewScore: false };

export function oneTimeCreditReducer(state = initialOneTimeCreditState, action: CreditTypes): IOneTimeCreditState {
    if (state === undefined) {
        return initialOneTimeCreditState;
    }

    switch (action.type) {
        case RECEIVE_ONETIME_CREDIT:
            return {
                ...state,
                oneTimeCreditData: action.oneTimeCreditData,
                purchasedReport: action.purchasedReport,
                pageViewScore: action.pageViewScore,
            };
        default:
            return state;
    }
}

let dailyCreditResponse: ICreditResponse | any;
const initialDailyState: IDailyCreditState = { isLoading: false, dailyCreditData: dailyCreditResponse };

export function dailyCreditReducer(state = initialDailyState, action: CreditTypes): IDailyCreditState {
    if (state === undefined) {
        return initialDailyState;
    }

    switch (action.type) {
        case REQUEST_DAILY_CREDIT:
            return {
                isLoading: true,
                dailyCreditData: state.dailyCreditData,
            };
        case RECEIVE_DAILY_CREDIT:
            return {
                isLoading: false,
                dailyCreditData: action.dailyCreditData,
            };
        default:
            return state;
    }
}

let creditAuthResponse: ICreditAuthResponse | any;
const creditAuthInitialState: ICreditAuthState = { isLoading: false, authData: creditAuthResponse };

export function creditAuthReducer(state = creditAuthInitialState, action: CreditAuthTypes): ICreditAuthState {
    if (state === undefined) {
        return creditAuthInitialState;
    }

    switch (action.type) {
        case REQUEST_CREDIT_AUTH:
            return {
                isLoading: true,
                authData: state.authData,
            };
        case RECEIVE_CREDIT_AUTH:
            return {
                isLoading: false,
                authData: action.authData,
            };
        default:
            return state;
    }
}

const creditEnrollmentInitialState: ICreditEnrollmentDetailsState = { creditEnrollmentDetails: {}, isCreditEnrollmentDetailsLoaded: false };

export function creditEnrollmentReducer(state = creditEnrollmentInitialState, action) {
    if (state === undefined) {
        return creditEnrollmentInitialState;
    }
    switch (action.type) {
        case CREDIT_ENROLLMENT_DETAILS:
            return {
                creditEnrollmentDetails: action.creditEnrollmentDetails
            };
        case LOADER_FOR_CREDIT_ENROLLMENT_DETAILS:
            return {
                ...state,
                isCreditEnrollmentDetailsLoaded: action.isCreditEnrollmentDetailsLoaded
            };
        default:
            return state;
    }
}
